import { css } from '@emotion/core';

/* eslint-disable import/prefer-default-export */

export var map = {
  name: "6jrdpz",
  styles: "width:100%;height:100%;object-fit:cover;"
};